import { createSelector } from '@reduxjs/toolkit';
const reduxPostBoardNotesReducer = (state) => state.reduxPostBoardNotes;
export const reduxPostBoardNotesDataSelector = createSelector(reduxPostBoardNotesReducer, (reducer) => reducer.data);
